import { render, staticRenderFns } from "./ShippingCity.vue?vue&type=template&id=d8b08280&scoped=true&"
import script from "./ShippingCity.vue?vue&type=script&lang=js&"
export * from "./ShippingCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b08280",
  null
  
)

export default component.exports